module.exports = __webpack_public_path__ + "img/dis4.77c043a3.png";